import { Typography, Grid } from "@mui/material";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface CustomerMail1Props {
    customerData: CustomerInterface
}

const CustomerMail1: React.FC<CustomerMail1Props> = ({
    customerData
}) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="caption" sx={{ color: "#333399" }}>E-Mail（携帯）</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body1">{customerData.ctm_mail1 ? customerData.ctm_mail1 : "未登録"}</Typography>
            </Grid>
        </Grid>
    );
}

export default CustomerMail1